import { FC, memo, useMemo } from "react";
import { ISupportMessage } from "../../../common/models/support/ISupport";
import { timeFormatter } from "../../../common/utils/helpers";
import { VoicePlayer } from "./VoicePlayer";

interface ISupportMessageBubbleProps {
  message: ISupportMessage;
  onVoiceFirstPlay?: (message: ISupportMessage) => void;
}

/** Инициалы сотрудника: «Иванов И.П.» */
function getManagerName(message: ISupportMessage): string {
  const manager = message.manager;
  if (!manager) return "";
  const initials = [manager.first_name, manager.middle_name]
    .filter(Boolean)
    .map((name) => `${name![0]}.`)
    .join("");
  return [manager.last_name, initials].filter(Boolean).join(" ");
}

/**
 * Пузырь сообщения: ответы поддержки справа тёмные, сообщения пользователя слева
 * светлые. Голосовое пользователя проигрывается, записать своё сотрудник не может
 */
export const SupportMessageBubble: FC<ISupportMessageBubbleProps> = memo(
  ({ message, onVoiceFirstPlay }) => {
    const isSupport = message.sender === "support";
    const time = useMemo(
      () =>
        timeFormatter({
          time: new Date(message.created_at),
          mode: "dd-MM-yyyy hh:mm",
        }),
      [message.created_at]
    );
    const managerName = isSupport ? getManagerName(message) : "";

    return (
      <div
        className={`mb-[20px] h-fit w-[280px] rounded p-[12px] ${
          isSupport
            ? "ml-auto bg-black text-white"
            : "bg-lightWhiteGray text-gray"
        }`}
      >
        {managerName && (
          <p className="mb-[3px] text-xxs text-lightGray">{managerName}</p>
        )}
        {message.voice ? (
          <VoicePlayer
            url={message.voice.url}
            durationMs={message.voice.duration_ms}
            waveform={message.voice.waveform}
            variant={isSupport ? "dark" : "light"}
            isUnlistened={!isSupport && !message.listened_at}
            onFirstPlay={
              !isSupport && !message.listened_at
                ? () => onVoiceFirstPlay?.(message)
                : undefined
            }
          />
        ) : (
          <p className="mb-[5px] whitespace-pre-wrap break-words text-xs font-medium">
            {message.text}
          </p>
        )}
        <time className="mt-[5px] block text-right text-xxs text-lightGray">
          {time}
        </time>
      </div>
    );
  }
);
